import { FileText, Users, Clock, MapPin, ShieldAlert, Banknote } from "lucide-react";
import { GAME_INFO, SAFETY, HEALTH } from "@/data/content";
import { t } from "@/data/texts";
import { Reveal } from "@/components/effects/Effects";

const ICONS = [Users, Clock, MapPin, FileText, ShieldAlert, Banknote];

export default function GameInfo({ rows }) {
  const dossierRows = (rows && rows.length) ? rows : GAME_INFO.rows;
  return (
    <section id="info" className="relative bg-[#080706] border-b border-white/10" data-testid="game-info-section">
      <div className="max-w-7xl mx-auto px-5 py-20 lg:py-28">
        <Reveal>
          <p className="text-xs tracking-[0.4em] text-nv uppercase mb-3">SLOŽKA / DOSSIER</p>
          <h2 className="font-head text-3xl sm:text-4xl text-neutral-100 mb-10 vhs-glitch">{t("gameinfo.title", GAME_INFO.title)}</h2>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 mb-6" data-testid="dossier-grid">
          {dossierRows.map((r, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={r.label} delay={i * 60}>
                <div className="bg-[#0b0a09] p-6 h-full">
                  <div className="flex items-center gap-2 text-nv mb-3">
                    <Icon className="w-4 h-4" />
                    <span className="text-[11px] tracking-[0.3em] uppercase text-neutral-500">{r.label}</span>
                  </div>
                  <p className="font-head text-xl text-neutral-100">{r.value}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <p className="text-sm text-neutral-500 mb-2">{t("gameinfo.priceNote", GAME_INFO.priceNote)}</p>
          <p className="text-sm text-red-500/90 tracking-wide border-l-2 border-[#4a0404] pl-3">{t("gameinfo.notice", GAME_INFO.notice)}</p>
        </Reveal>

        {/* Safety + Health */}
        <div className="grid md:grid-cols-2 gap-6 mt-14">
          <Reveal>
            <div className="border border-white/10 bg-[#0b0a09] p-7 h-full">
              <h3 className="font-head text-xl text-neutral-100 mb-5 flex items-center gap-2">
                <ShieldAlert className="w-5 h-5 text-nv" /> {SAFETY.title}
              </h3>
              <ul className="space-y-3 text-sm text-neutral-400">
                {SAFETY.points.map((p) => (
                  <li key={p} className="flex gap-3">
                    <span className="text-nv mt-1">▸</span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="border border-red-900/40 bg-red-950/10 p-7 h-full">
              <h3 className="font-head text-xl text-red-400 mb-3 flex items-center gap-2">
                <ShieldAlert className="w-5 h-5" /> {HEALTH.title}
              </h3>
              <p className="text-sm text-neutral-400 mb-3">{HEALTH.intro}</p>
              <ul className="grid grid-cols-2 gap-2 text-sm text-neutral-400 mb-4">
                {HEALTH.points.map((p) => (
                  <li key={p} className="flex gap-2">
                    <span className="text-red-600">✕</span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              <p className="text-xs text-neutral-500 border-t border-white/5 pt-3">{HEALTH.note}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
